import Enum from './Enum';

export const UserStatusEnum = new Enum({
    ACTIVE_AND_IDLE: 'ACTIVE_AND_IDLE',
    ACTIVE_AND_EXECUTING: 'ACTIVE_AND_EXECUTING',
    LOCATION_MISSING: 'LOCATION_MISSING',
    BUSY_MANUAL: 'BUSY_MANUAL',
    BUSY: 'BUSY',
    LOGGED_OUT: 'LOGGED_OUT',
    NEVER_LOGGED_IN: 'NEVER_LOGGED_IN',
    DISABLED: 'DISABLED'
});

export const OrderedUserStatus = [
    'ACTIVE_AND_IDLE',
    'ACTIVE_AND_EXECUTING',
    'LOCATION_MISSING',
    'BUSY_MANUAL',
    'LOGGED_OUT'
];

export const UserTabEnum = new Enum({
    OTHERS: 'OTHERS',
    WORKING: 'WORKING'
});

export const DEFAULT_USER_TABS = ['WORKING', 'OTHERS'];
